// Apolo IDE — SynthesisView helpers (Sprint v4 Epic S4 WS S4.3).
//
// Pure functions extracted out of SynthesisView.jsx so the component file
// stays HMR-clean (Vite's react-refresh plugin complains when a JSX file
// exports both a component and non-component values).
//
// All exports are deterministic + side-effect free + safe to import from
// tests OR the component without dragging React along.

const ATTRIBUTION_RE = /\[Subagent\s+(\d+)\s*:\s*([^\]]+)\]/g;
const CONFIDENCE_RE = /\(confidence:\s*(high|medium|low)\)/gi;

export function confidenceTone(level) {
  switch ((level || '').toLowerCase()) {
    case 'high':
      return 'bg-apolo-success/15 text-apolo-success';
    case 'medium':
      return 'bg-apolo-warning/15 text-apolo-warning';
    case 'low':
      return 'bg-apolo-error/15 text-apolo-error';
    default:
      return 'bg-apolo-surface2 text-apolo-textTertiary';
  }
}

function decorateConfidence(chunk, baseKey) {
  if (typeof chunk !== 'string' || chunk.length === 0) return [];
  const out = [];
  let cursor = 0;
  let key = baseKey;
  CONFIDENCE_RE.lastIndex = 0;
  let m;
  while ((m = CONFIDENCE_RE.exec(chunk)) !== null) {
    const start = m.index;
    if (start > cursor) {
      out.push({ type: 'text', key: `t-${key++}`, value: chunk.slice(cursor, start) });
    }
    out.push({
      type: 'confidence',
      key: `c-${key++}`,
      level: m[1].toLowerCase(),
      raw: m[0],
    });
    cursor = start + m[0].length;
  }
  if (cursor < chunk.length) {
    out.push({ type: 'text', key: `t-${key++}`, value: chunk.slice(cursor) });
  }
  return out;
}

/**
 * Walk `text` and emit token nodes:
 *   - { type: 'attribution', key, index, label, raw }  for [Subagent N: ...]
 *   - { type: 'confidence',  key, level, raw }         for (confidence: …)
 *   - { type: 'text',        key, value }              everything else
 *
 * Two-pass so attribution doesn't swallow a confidence tag and vice versa.
 */
export function decorateSynthText(text) {
  if (typeof text !== 'string' || text.length === 0) return [];
  const out = [];
  let cursor = 0;
  let key = 0;
  ATTRIBUTION_RE.lastIndex = 0;
  let m;
  while ((m = ATTRIBUTION_RE.exec(text)) !== null) {
    const start = m.index;
    if (start > cursor) {
      out.push(...decorateConfidence(text.slice(cursor, start), key));
      key += 100;
    }
    out.push({
      type: 'attribution',
      key: `attr-${key++}`,
      index: Number(m[1]),
      label: m[2].trim(),
      raw: m[0],
    });
    cursor = start + m[0].length;
  }
  if (cursor < text.length) {
    out.push(...decorateConfidence(text.slice(cursor), key));
  }
  return out;
}

export function fmtDuration(ms) {
  if (!ms || ms <= 0) return '—';
  if (ms < 1000) return `${ms}ms`;
  return `${(ms / 1000).toFixed(1)}s`;
}

export function fmtCost(usd) {
  if (typeof usd !== 'number' || !Number.isFinite(usd) || usd === 0) return '$0';
  if (usd < 0.001) return '<$0.001';
  return `$${usd.toFixed(usd < 0.01 ? 4 : 3)}`;
}
